export function serializeObjectToParams(params) {
  if (typeof params !== "object") {
    return "";
  }
  return `?${Object.keys(params).map((key) => `${key}=${params[key]}`).join("&")}`;
}
